import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';

import { Config } from './config';

//const production = false;
const production = true;

@Injectable()
export class ConfigService {

  public loaded: boolean = false;
  public config: Config = new Config();

  constructor(public http: Http) {
    if (!this.getLoaded()) {
      let item: any;
      if (production) {
        item = {
          id: 1000,
          url: 'http://api.odusseuserp.com/',
          urlSpecific: 'http://api.odusseuserp.com/',
          urlLanguage: 'http://api.odusseuserp.com/',
          flag: './assets/data/img/flags/',
          date: '02/03/2017',
          version: '1.0.0',
          local: false
        };
      }
      else {
        item = {
          id: 1000,
          url: 'http://localhost:8001/',
          urlSpecific: 'http://localhost:8001/',
          urlLanguage: 'http://localhost:8001/',
          flag: './assets/data/img/flags/',
          date: '02/03/2017',
          version: '1.0.0',
          local: false
        };
      }
      let config: Config;
      config = this.getConfig();
      config.setValue(item);
    }
  }

  setConfig(config: Config) {
    this.config = config;
  }

  getConfig() {
    return this.config;
  }

  getItem(): Observable<any> {
    let file_name: string;
    file_name = 'config.json';
    if (!production) {
      file_name = './assets/data/json/config/config_dev.json';
    }
    return this.http.get(file_name)
      .map(this.extractData)
      .catch(this.handleError);
  }

  extractData(res: Response) {
    const body = res.json();
    return body;
  }

  handleError(error: any) {
    const errMsg = (error.message) ? error.message :
      error.status ? `${error.status} - ${error.statusText}` : 'Server error';
    return Observable.throw(errMsg);
  }

  setLoaded(loaded: boolean) {
    this.loaded = loaded;
  }

  getLoaded() {
    return this.loaded;
  }

}
